<template>
  <!-- 时间倒计时 -->
  <span class="time">{{realTime}}</span>
</template>

<script>
  import { storage, messageError, messageSuccess, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { checkData, hex_to_ten, hexCharCodeToStr } from '../../../../static/js/utils/util'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
  let vm
  let list = [], n = 0

  export default {
    name:'TimeCountDown',
    components: {
    },
    props: {
      time: {
        type: String,
        value: ''
      },
      timeReset: {
        type: Boolean,
        value: false
      },
      index: {
        type: Number,
        value: 0
      }
    },
    data() {
      return {
        realTime: ''
      }
    },
    created() {
      vm = this
    },
    mounted () {
      console.log('this', this.$route)
      this.init()
    },
    destroyed () {
      this.clearIntervalTimer()
    },
    methods: {
      // 计算时间
      jsRealTime(times) {
        let timess = Math.abs(times)
        let hour = Math.floor(timess / 3600)
        let minutes = Math.floor((timess - hour * 3600) / 60)
        let seconds = Math.floor((timess - hour * 3600 - minutes * 60) % 60)
        let value =
          (hour < 10 ? '0' + hour : hour) + ":" +
          (minutes < 10 ? '0' + minutes : minutes) + ":" +
          (seconds < 10 ? '0' + seconds : seconds)
        return value
      },
      // 倒计时
      countDown(n) {
        // console.log(n, list[n])
        let vm = this
        let times = list[n].times
        // console.log('所有秒：', times)

        let realTime = ''
        // 倒计为0，停止
        if (list[n].timeReset) {
          // console.log('n::', n, list)
          if (list[n].times == 0) {
            realTime = '00:00:00'
            clearInterval(list[n].timer)
            // vm.triggerEvent('reset', { index: list[n].index })
            vm.$emit('reset', { index: list[n].index })
          }
          if (times > 0) {
            times--
            realTime = vm.jsRealTime(times)
          }

          // 判断是否在整时，触发事件（商城系统使用）
          if ((Math.abs(times)) % 3600 == 0) {
            // vm.triggerEvent('timeFull', { index: list[n].index, realTime, times })
            vm.$emit('timeFull', { index: list[n].index, realTime, times })
          }
        } else {
        // 倒计为0， 不停止，计算超时
          // console.log('times', times, n)
          times--
          // realTime = (times > 0 ? '' : '-') + vm.jsRealTime(times)
          realTime = vm.jsRealTime(times)

          // 突变超时处理，触发事件
          if (times == -1) {
            // console.log('list[n].index::', list[n].index)
            // vm.triggerEvent('timeout', { index: list[n].index, realTime: realTime })
            vm.$emit('timeout', { index: list[n].index, realTime: realTime })
          }

          // 判断是否在整时、整日、整月，触发事件(寄存柜使用)
          if ((Math.abs(times))%3600 == 1 && times < 0) {
            // console.log(list[n].index)
            // vm.triggerEvent('timeAddOne', { index: list[n].index, realTime })
            vm.$emit('timeAddOne', { index: list[n].index, realTime })
          }

        }

        // 更新当前显示时间
        list[n].times = times
        vm.realTime = realTime
      },
      // 循环
      loop(n) {
        let vm = this
        return setInterval(function () {
          vm.countDown(n)
        }, 1000)
      },
      // 初始化执行
      init() {
        let vm = this
        let time = vm.time
        let timeArr = time.indexOf('-') == -1 ? time.split(':') : time.split('-')[1].split(':')
        // console.log('timeArr::', timeArr)
        // 时间总数（秒）
        let times = Number(timeArr[0]) * 60 * 60 + Number(timeArr[1]) * 60 + Number(timeArr[2])
        times = time.indexOf('-') == -1 ? times : -(times)
        // 当前显示时间
        // let realTime = time
        let realTime = vm.jsRealTime(times)
        vm.realTime = realTime


        /* 获取list */
        let timer = vm.loop(n)
        n++
        let timeReset = vm.timeReset
        let index = vm.index
        list.push({ times, timer, timeReset, index })

        // console.log('list:::', list)
      },
      // 清除循环定时器
      clearIntervalTimer() {
        list.forEach(function (item) {
          clearInterval(item.timer)
        })
        list = []
        n = 0
      }
    },
    watch: {
    },
  }
</script>

<style lang="less">
  
</style>


// WEBPACK FOOTER //
// src/components/Bookcase/Common/TimeCountDown.vue